export default __webpack_public_path__ + "static/media/bjt_amp_thumb.e0ca40b0.png";